import { render, staticRenderFns } from "./CmajForm.vue?vue&type=template&id=87933038&"
import script from "./CmajForm.vue?vue&type=script&lang=js&"
export * from "./CmajForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports